import {Shop} from "@/entities/shop";

export type ShopBalloonData = {
    name?: string;
    address?: string;
    phone?: string;
    operatingMode?: string;
};

export const mapShopBalloon = (shop: Shop): ShopBalloonData => ({
    name: shop.name || undefined,
    address: shop.address ? `${shop.address}${shop.metro ? `, ${shop.metro}` : ""}` : undefined,
    phone: shop.phone ? shop.phone.replaceAll("|", ", ") : undefined,
    operatingMode: shop.operating_mode || undefined,
});
